/**
 * cn(...) — conditional className joiner.
 *
 * In the real monorepo this is `restos-waiter/src/lib/utils.ts` using `twMerge(clsx(...))`.
 * To keep this scaffold dependency-light, we ship a tiny equivalent that joins truthy class
 * fragments. Swap for twMerge+clsx when the shared package is vendored.
 */
export type ClassValue = string | number | false | null | undefined;

export function cn(...parts: ClassValue[]): string {
  return parts.filter(Boolean).join(" ");
}

/** Format ₸ money impact. */
export function formatTenge(amount: number): string {
  return new Intl.NumberFormat("ru-RU", {
    style: "currency",
    currency: "KZT",
    maximumFractionDigits: 0,
  }).format(amount);
}

/** "8 мин назад" / "только что" relative time, ru. */
export function timeAgo(iso: string, nowMs: number = Date.now()): string {
  const diff = Math.max(0, nowMs - new Date(iso).getTime());
  const min = Math.floor(diff / 60000);
  if (min < 1) return "только что";
  if (min < 60) return `${min} мин назад`;
  const h = Math.floor(min / 60);
  if (h < 24) return `${h} ч назад`;
  const d = Math.floor(h / 24);
  return `${d} дн назад`;
}

/** Seconds → "2:22" mm:ss. */
export function formatSeconds(total: number): string {
  const m = Math.floor(total / 60);
  const s = Math.round(total % 60);
  return `${m}:${s.toString().padStart(2, "0")}`;
}

/** ISO timestamp → "осталось 12 мин" TTL hint, or null when expired. */
export function ttlRemaining(iso: string, nowMs: number = Date.now()): string | null {
  const diff = new Date(iso).getTime() - nowMs;
  if (diff <= 0) return null;
  const min = Math.ceil(diff / 60000);
  if (min < 60) return `осталось ${min} мин`;
  const h = Math.ceil(min / 60);
  return `осталось ${h} ч`;
}
